export function isLayerTreeGroupConfig(item) {
    return !!item.groupId;
}
export function isLayerTreeLayerConfig(item) {
    return !!item.layerId;
}
export function isLayerSwitcherGroupState(item) {
    return !!item.groupId;
}
export function isLayerSwitcherLayerState(item) {
    return !!item.layerId;
}
export function isLayerSwitcherGroup(item) {
    return (isLayerSwitcherGroupState(item) || isLayerTreeGroupConfig(item));
}
//# sourceMappingURL=layerGroup.js.map